module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Regular-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Regular-webfont.svg
// module id = 356
// module chunks = 0